/* eslint-disable max-len */
import { motion } from 'framer-motion'
import React,{useEffect,useState} from 'react'
import { useContext } from 'react'
import WishlistContext from '../../Components/Context/WishlistContext'
import ProductCard from '../../Components/ProductCard'
import ProductSkeleton from '../../Components/ProductCard/ProductSkeleton'
import EmptyWishlistScreen from './EmptyScreen'

export default function WishlistCard(props) {
    const {selectedWishlist,setaddtocartPopup,setselectedWishlist,productList,loading,addtocartPopup,removeAll,removeParticular,handleRemoveModal}=useContext(WishlistContext)
    return (
        <motion.div
            animate={{ opacity: 1, x: 0 }}
            initial={{ opacity: 0, x: -10 }}
            exit={{ opacity: 0, x: -10 }}
            transition={{ duration: 0.15 }} 
            key={selectedWishlist?.collection_id}
            className={`xl:ml-[20%] xl:w-[80%] md:px-[46px] lg:pr-12 px-4 pt-[18px] pb-10 w-full`} style={{height:'75vh'}}>
            <div className="w-full flex sm:flex-row flex-col sm:items-center justify-between relative">
                <div className="flex justify-start items-center">
                    <p className="text-xs10 font-semibold text-[#090406]">{selectedWishlist?.collection_name}</p>
                    <span className="text-xs font-semibold text-[#808285] pl-3.5 self-end pb-1">({productList?.length} items)</span>
                    {/* <div className="absolute top-0 right-0 flex items-center xl:hidden">
                        <img src="/images/edit-2.svg" alt="edit-icon" className="px-3" data-bs-toggle="modal" data-bs-target="#editWishlist"/>
                        <img src="/images/Icon-feather-trash-2.svg" alt="delete-icon" className="" data-bs-toggle="modal" data-bs-target="#deleteWishlist" />
                    </div> */}
                </div>
                {productList.length>0 &&(
                    <div className="flex items-center sm:justify-start sm:pt-0 pt-4 sm:pr-[70px] xl:pr-0">
                        <button 
                            onClick={()=>handleRemoveModal('','','removeAll')}
                            type="button" className="text-xs13 font-semibold text-[#808285] pr-3 border-r border-[#808285]" data-bs-toggle="modal" data-bs-target="#removeAllProducts">
                            Remove all products
                        </button>
                        <button 
                            onClick={()=>setaddtocartPopup('all')}
                            type="button" className="text-xs13 font-semibold text-[#808285] pl-3" data-bs-toggle="modal" data-bs-target="#addAlltoCart">
                            Add all to Cart
                        </button>
                    </div>
                )}
            </div>
            <>{loading && <ProductSkeleton />}</>
            <>{!loading && productList?.length > 0 &&<>{productList.map((prod,i)=>(
                <div key={`${prod.INVENTORY_ITEM_ID}-${i}-${prod.DESCRIPTION}`} style={{paddingTop:'9px',paddingBottom:'9px'}}>
                    <ProductCard 
                        type="wishlist"
                        setaddtocartPopup={setaddtocartPopup}
                        prod={prod}
                        STOCK_VISIBILITY={true}
                        handleCrud={handleRemoveModal}
                        selectedWishlist={selectedWishlist}/>
                </div>
            ))}
            </>
            }</>
            <>{productList?.length===0 && !loading && 
                <EmptyWishlistScreen selectedWishlist={selectedWishlist}/>}</>
        </motion.div>
    )
}
